<template>
    <div class="management-contract">
        <el-form ref="form" :model="filtersForm" label-width="80px" inline>
            <el-row>
                <el-form-item label="处方编号">
                    <el-input v-model="filtersForm.orderNo" placeholder="请输入处方单号"></el-input>
                </el-form-item>
                <el-form-item label="处方类型">
                    <el-select v-model="filtersForm.orderType">
                        <el-option v-for="item in orderTypeList"
                                   :value="item.value"
                                   :key="item.value"
                                   :label="item.label"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开方医院">
                    <el-select v-model="filtersForm.hos">
                        <el-option :value="hosName" :key="hosName" :label="hosName"></el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="开方医生">
                    <el-input v-model="filtersForm.docName" placeholder="请输入开方医生"></el-input>
                </el-form-item>
                <el-form-item label="患者姓名">
                    <el-input v-model="filtersForm.compatName" placeholder="请输入患者姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clearSearch">重置</el-button>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-row>
        </el-form>
        <el-radio-group v-model="checkedStatus">
            <el-radio-button v-for="state in states" :label="state.label" :key="state.text">{{state.text}}
            </el-radio-button>
        </el-radio-group>
        <el-table :data="list" v-loading="loading" border>
            <el-table-column prop="orderNo" label="处方编号"></el-table-column>
            <el-table-column prop="status" :formatter="formatterStatus" label="处方状态"></el-table-column>
            <el-table-column prop="orderType" :formatter="formatterType" label="处方类型"></el-table-column>
            <el-table-column prop="diagnosis" label="诊断"></el-table-column>
            <el-table-column prop="hosName" label="开方医院"></el-table-column>
            <el-table-column prop="docName" label="开方医生"></el-table-column>
            <el-table-column prop="createTime" :formatter="formatterTime" label="开方时间"></el-table-column>
            <el-table-column v-if="checkedStatus!=='ISSUE'" prop="auditorName" label="审核药师" ></el-table-column>
            <el-table-column v-if="checkedStatus!=='ISSUE'" prop="auditTime" :formatter="formatterTime" label="审核时间"></el-table-column>
            <el-table-column prop="compatName" label="患者姓名"></el-table-column>
            <el-table-column prop="compatGender" label="患者性别" :formatter="formatterSex"></el-table-column>
            <el-table-column prop="compatAge" label="患者年龄"></el-table-column>
            <el-table-column v-if="checkedStatus === 'AUDIT'" label="拒绝原因" >
                <template slot-scope="scope">
                    <span class="color_red">{{scope.row.refuseReason}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click.prevent="showCheckDialog(scope.row.id)" type="primary" size="small">
                        {{scope.row.status=='ISSUE'?'审核':'详情'}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="pagination-wrapper" type="flex" justify="end">
            <el-pagination
                    layout="prev, pager, next"
                    :current-page.sync="page.pageNum"
                    :total="page.total"
                    @current-change="onCurrentChange"
            ></el-pagination>
        </el-row>
        <check-dialog ref="checkDialog" v-if="orderInfo" :info="orderInfo" @handler="checkHandler"></check-dialog>
    </div>
</template>

<script>
  import {MessageBox, Message} from 'element-ui'
  import {tokenCache} from "../../lib/cache/Token"
  import {timeFormat} from "ty-vue-filters";
  import {ORDER_TYPE_LIST} from "../../lib/config"
  import {sexFilter} from "../../lib/filters"
  import CheckDialog from "../../components/prescription/check-dialog"
  import {filter_drug_type} from "../../filters/prescription";
  import {recipeService} from "../../lib/service/recipe";
  import {loginInfoCache} from "../../lib/cache/LoginInfo";

  const PAGE = {
    pageNum: 1,
    pageSize: 10,
    pages: 1,
    total: 0
  }

  export default {
    data() {
      return {
          hosName: '',
        orderInfo: {},
        daterange: [],
        filtersForm: {
          orderNo: "",
          patName: "",
          orderType: "",
          hos: '',
        },
        hosId: '',
        list: [],
        orderTypeList: ORDER_TYPE_LIST,
        states: [
          {
            label: "ISSUE",
            text: "待审核"
          },
          {
            label: "WAITREPEAT",
            text: "已审核"
          },
        ],
        loading: false,
        page: PAGE,
        checkedStatus: "ISSUE"
      };
    },
    components: {CheckDialog},
    watch: {
      daterange(val) {
        this.filtersForm.startDate = val ? val[0] : "";
        this.filtersForm.endDate = val ? val[1] : "";
      },
      checkedStatus: {
        handler() {
          this.pages = PAGE;
            if (!this.hosId){
                const {doc} = loginInfoCache.get();
                this.hosId = doc.hosId
                this.hosName = doc.hosName
                this.filtersForm.hos = doc.hosName
            }
            this.getList();
        },
        immediate: true
      }
    },
    methods: {
      filter_drug_type,
      clearSearch() {
        this.filtersForm = {
          orderNo: "",
          patName: "",
          orderType: "",
          hos: HOSNAME,
        }
      },
      async showCheckDialog(id) {
        const obj = await recipeService.info(id)
        if (Object.values(obj).length>0) {
          this.orderInfo = obj
          console.log(this.orderInfo)
          this.$refs.checkDialog.show()
        }
      },
      checkHandler(h) {
        if (h == 'refuse') {
          this.onRefuse()
        } else {
          this.onAccept()
        }
      },
      onRefuse() {
        MessageBox.prompt('请输入拒绝理由?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async (inputValue) => {
          const options = {
            orderId: this.orderInfo.id,
            status: 'REFUSE',
            reason: inputValue.value,
            token: tokenCache.get()
          };
          const {code, obj, msg} = await this.$http('smarthos.recipe.order.audit', options)
          if (code == '0') {
            this.$refs.checkDialog.close()
            this.getList();
          }
          else {
            this.$refs.checkDialog.close()
          }
        }).catch(() => {
          return;
        });
      },
      onAccept() {
        MessageBox.confirm('确定进行此操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async () => {
          const options = {
            orderId: this.orderInfo.id,
            status: 'WAITREPEAT',
            token: tokenCache.get()
          };
          const {code, obj, msg} = await this.$http('smarthos.recipe.order.audit', options)
          if (code == '0') {
            this.$refs.checkDialog.close()
            this.getList();
          }
          else {
            this.$refs.checkDialog.close()
          }
        })

      },

      goToDetails(id) {
        this.$router.push({
          path: "/main/management-contract-details",
          query: {id}
        });
      },
      async reCall(id) {
        MessageBox.confirm('确认召回处方?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          console.log("id====>", id);
          let options = {
            token: localStorage.getItem("token"),
            orderId: id
          };
          let res = await this.$http("smarthos.recipe.order.recall", options);
          if (res.code == 0) {
            Message({
              showClose: true,
              message: "操作成功",
              type: "success"
            });
          }
        }).catch(() => {
        });
      },
      onSubmit() {
        this.getList();
      },
      onCurrentChange(pageNum) {
        this.page.pageNum = pageNum;
        this.getList();
      },
      async getList() {
        this.loading = true;
        const options = {
          status: this.checkedStatus,
          token: tokenCache.get(),
          ...this.page,
          ...this.filtersForm,
          hosId: this.hosId,

        }
        const {code, list, page, msg} = await this.$http('smarthos.recipe.order.auditor.list.page', options)
        if (code === "0") {
          this.loading = false;
          this.list = list;
          this.page = page;
        } else {
          // this.$message.error(msg);
        }
      },
      formatterTime(row, column, time) {
        return timeFormat(time, "%Y/%m/%d %H:%M");
      },
      formatterSex(row, column, compatGender) {
        return sexFilter(compatGender, 1);
      },
      formatterType(row, column, code) {
         return filter_drug_type(code)
      },
      formatterStatus(row, column, code) {
        const statusObj = {
          RECALL: "已召回",
          REFUSE: "已拒绝",
          ISSUE: "待审核",
          AUDIT: "已审核",
          PAY: "已审核",
          WAITTAKE: "已审核",
          SHIPPING: "已审核",
          COMPLETE: "已审核",
          COMMENT: "已审核",
          CANCEL: "已作废",
        };
        return statusObj[code];
      },
    }
  };
</script>

<style lang="scss">
    .management-contract {
        .el-form {
            padding-top: 22px;
            border-top: 1px solid #f5f5f5;
        }
        .el-table {
            margin-top: 15px;
        }
        .pagination-wrapper {
            padding: 20px 0;
        }
        .el-table .cell {
            max-height: 69px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
    }
</style>
